import React, { useState } from 'react';
import { StaticQuery, graphql, Link } from "gatsby"
import { Container, Row, Col, Dropdown, FormControl } from "react-bootstrap"
import Icon from "../../assets/ArrowWithStem.svg"
import RtapPhoneNumber from "../RtapPhoneNumber/RtapPhoneNumber"

//import { document } from "browser-monads"

// The forwardRef is important!!
// Dropdown needs access to the DOM node in order to position the Menu
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href="/homepage"
    className="dropdowns-click-element"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
      focusInput();
    }}
  >
    {children}
  </a>
));

function focusInput() {
  setTimeout(function(){
    const activeDropDownInput = document.querySelector(".dropdown.show input")
    const activeDropDown = document.querySelector(".dropdown.show ul")
    if(activeDropDownInput) {
      activeDropDownInput.focus()
    }
    if(activeDropDown) {
      activeDropDown.style.display = "none"
    }
  }, 300);
}

// forwardRef again here!
// Dropdown needs access to the DOM of the Menu to measure it
const CustomMenu = React.forwardRef(
  ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
    const [value, setValue] = useState('');
    const valueRef = React.useRef();

    const handleChange = e => {
      const activeDropDown = document.querySelector(".dropdown.show ul")
      if(activeDropDown) {
        if(valueRef.current.value === "") {
          activeDropDown.style.display = "none"
        }else {
          activeDropDown.style.display = "block"
        }
      }
      setValue(valueRef.current.value);
    };

    return (
      <div
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}
      >
        <FormControl
          className="find-an-expert-input"
          placeholder="Type here to filter by name"
          onChange={handleChange}
          ref={valueRef}
          value={value}
        />
        <ul className="list-unstyled">
          {React.Children.toArray(children).filter(
            (child) =>
              !value || child.props.children.toString().toLowerCase().indexOf(value.toLowerCase()) !== -1,
          )}
        </ul>
      </div>
    );
  },
);


function peopleSelect(data) {
  //console.log(data)
  let returnItems = []
  data.map(function(node, index) {
    if(node.title) {
      returnItems.push(
        <Link key={"find-expert-"+index} className="nav-link" to={node.path.alias}>{node.title}</Link>
      )
    }
    return true;

  })
  return (returnItems)
}

function serviceSelect(data) {

  // console.log("serviceSelect")
  // console.log(data)

  let returnItems = []
  data.map(function(node, index) {
    if(node.title) {
      returnItems.push(
        <Link key={"find-service-"+index} className="nav-link" to={node.path.alias}>{node.title}<br/><span>{node.field_summary_plain}</span></Link>
      )
    }
    return true;

  })
  return (returnItems)
}

let field_phone_number_rtap = "020 7600 1660";

const FooterFindExpert = () => (

  <StaticQuery

    query={graphql`
      query {
        experts: allNodePeople(filter: {field_hide_person: {eq: false}, moderation_state: {eq: "published"}}, sort: {title: ASC}) {
          nodes {
            title
            path {
              alias
            }
          }
        }
        services: allNodeProductOrService(filter: {moderation_state: {eq: "published"}, field_include_in_the_footer_list: {eq: true}}, sort: {title: ASC}) {
          nodes {
            title
            field_summary_plain
            path {
              alias
            }
          }
        }
      }
    `}

    render={data => (
      <section className="find-expert">
        <Container fluid>
          <Row className="g-0">
            <Col sm={12} lg={{span:10, offset:1}}>
              <Container fluid>
                <Row>
                  <Col xs={12} md={6}>
                    <div className="find-expert__title">
                      <hr/>
                      <div className="h3">Speak to us</div>
                    </div>
                    <RtapPhoneNumber number={field_phone_number_rtap} additionalclasses="find-expert__phone-number" />
                    <div>
                      <a className="find-expert__link" href="/contact-us/">Other ways to contact us <Icon width="24" /></a>
                    </div>
                    <div className="find-office__title">
                      <hr/>
                      <div className="h4">Find us</div>
                    </div>
                    <p>
                      Our London office:<br/>
                      25 Copthall Ave,<br/>
                      London EC2R 7AH
                    </p>
                    <div>
                      <a className="find-office__link" href="/contact-us/">Find our other offices <Icon width="24" /></a>
                    </div>

                  </Col>
                  <Col xs={12} md={6}>
                    <div className="find-expert__title">
                      <hr/>
                      <div className="h3">Find the right expert</div>
                    </div>
                    <div className="find-expert__dropdowns">
                      <Dropdown navbar>
                        <p>Search by name:</p>
                        <div className="find-expert__dropdowns-wrapper">
                          <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                            <span className="with-btn">Type here to filter by name</span>
                          </Dropdown.Toggle>
                          <Dropdown.Menu as={CustomMenu}>
                            {peopleSelect(data.experts.nodes)}
                          </Dropdown.Menu>
                        </div>
                      </Dropdown>

                      <Dropdown navbar>
                        <p>Or tell us what service you need:</p>
                        <div className="find-expert__dropdowns-wrapper">
                          <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                            <span className="with-btn">Type here to filter by name</span>
                          </Dropdown.Toggle>
                          <Dropdown.Menu as={CustomMenu}>
                            {serviceSelect(data.services.nodes)}
                          </Dropdown.Menu>
                        </div>
                      </Dropdown>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </Container>
      </section>
    )}
  />

)

export default FooterFindExpert
